import { SegmentedProps } from 'antd'
import { SegmentedValue } from 'antd/es/segmented'
import { calculateDateRange } from 'shared/helpers/calculateDateRange'
import { useAppSearchParams } from 'shared/libs/hooks/useAppSearchParams'
import { ParamKey } from 'shared/types/QueryModel'

import { useEffect, useState } from 'react'

import { useLocation } from 'react-router-dom'

import Segmented from '../Segmented/Segmented'

interface ChangeSegmentedOption {
  replace: boolean
}

interface Props extends SegmentedProps {
  withPage?: boolean
}
const SegmentedFilter = ({ withPage, ...props }: Props) => {
  const location = useLocation()
  const { setParams, getAllParams } = useAppSearchParams()
  const { start_date: currentStart, end_date: currentEnd } = getAllParams()

  const [segmentedRangeValue, setSegmentedRangeValue] =
    useState<SegmentedValue | null>(null)

  const handleChangeSegmented = (
    value: SegmentedValue,
    options?: ChangeSegmentedOption,
  ) => {
    const { start_date, end_date } = calculateDateRange(value.toString())
    if (
      start_date &&
      end_date &&
      (currentStart !== start_date || currentEnd !== end_date)
    ) {
      setTimeout(() => {
        setParams(
          [
            {
              key: 'start_date',
              value: start_date,
            },
            {
              key: 'end_date',
              value: end_date,
            },
            ...(withPage
              ? [
                  {
                    key: 'page' as ParamKey,
                    value: '1',
                  },
                ]
              : []),
          ],
          options,
        )
      })
    }
  }

  const onChangeSegmented = (
    value: SegmentedValue,
    options?: ChangeSegmentedOption,
  ) => {
    handleChangeSegmented(value, options)
    setSegmentedRangeValue(value)
  }

  useEffect(() => {
    if (segmentedRangeValue && !currentStart && !currentEnd) {
      const timer = setTimeout(() => {
        onChangeSegmented('today', {
          replace: true,
        })
      })

      return () => clearTimeout(timer)
    }
  }, [location])

  useEffect(() => {
    if (currentStart && currentEnd) {
      const { getdiffDaysOption } = calculateDateRange()
      const segmentedValue = getdiffDaysOption(currentStart, currentEnd)
      if (
        typeof segmentedValue === 'string' &&
        segmentedValue !== segmentedRangeValue
      ) {
        onChangeSegmented(segmentedValue)
      } else if (typeof segmentedValue !== 'string') {
        setSegmentedRangeValue(null)
      }
    } else {
      onChangeSegmented('today', {
        replace: true,
      })
    }
  }, [currentStart, currentEnd])

  return (
    <Segmented
      onChange={onChangeSegmented}
      value={segmentedRangeValue as SegmentedValue | undefined}
      {...props}
    />
  )
}

export default SegmentedFilter
